import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import classNames from 'classnames';
import { withRouter } from 'react-router';

import popQueryString from 'rebook/apps/utils/urls/popQueryString';
import OrderByNewPopular from 'rebook/apps/catalog/components/Filters/OrderByNewPopular';
import FilterBySubscriptionType from 'rebook/apps/catalog/components/Filters/FilterBySubscriptionType';
import FilterBookType from 'rebook/apps/catalog/components/Filters/FilterBookType';
import Button from 'rebook/apps/base/components/Button';

import styles from './style.scss';


class CatalogFilter extends React.Component {
  resetFilters() {
    this.props.history.push({
      search: popQueryString(get(this, 'props.location.search', ''), ['o', 's', 't']),
    });
    this.props.onResetFilter();
  }

  render() {
    const {
      isOrderEnabled, orderBy, onChangeOrder,
      isSubscriptionEnabled, subscriptionId, onChangeSubscription,
      isBookTypeEnabled, bookType, onChangeBookType, isResultEmpty,
      orderByValues,
    } = this.props;
    return (
      <div className={styles.container}>
        {isOrderEnabled && (
          <OrderByNewPopular
            orderBy={orderBy}
            orderByValues={orderByValues}
            width={250}
            onChange={(value) => onChangeOrder(value)} />
        )}
        {isSubscriptionEnabled && (
          <FilterBySubscriptionType
            subscriptionId={subscriptionId}
            width={239}
            onChange={(value) => onChangeSubscription(value)} />
        )}

        {isBookTypeEnabled && (
          <FilterBookType
            bookType={bookType}
            width={242}
            onChange={(value) => onChangeBookType(value)} />
        )}
        {isResultEmpty && (
          <Button
            extraClassName={classNames(styles.resetFilters, 'jest-reset-filter-button')}
            theme="secondary"
            size="small"
            handleClick={()=>this.resetFilters()}>
            Сбросить фильтр
          </Button>
        )}
      </div>
    );
  }
};

CatalogFilter.propTypes = {
  isOrderEnabled: PropTypes.bool,
  isSubscriptionEnabled: PropTypes.bool,
  isBookTypeEnabled: PropTypes.bool,
  orderBy: PropTypes.string,
  orderByValues: PropTypes.array,
  subscriptionId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
  ]),
  bookType: PropTypes.string,
  isResultEmpty: PropTypes.bool,
  onResetFilter: PropTypes.func,
  onChangeOrder: PropTypes.func,
  onChangeSubscription: PropTypes.func,
  onChangeBookType: PropTypes.func,
};

CatalogFilter.defaultProps = {
  isOrderEnabled: true,
  isSubscriptionEnabled: true,
  isBookTypeEnabled: true,
  orderBy: 'popular',
  subscriptionId: null,
  isResultEmpty: false,
  onResetFilter: function() {},
  onChangeOrder: function() {},
  onChangeSubscription: function() {},
  onChangeBookType: function() {},
};

export default withRouter(CatalogFilter);
